export const routes = {
  oauth2: {
    facensRedirectLink: `/oauth2/facens`,
    callback: '/oauth2/facens/bo/callback?code={code}',
  },
  newton: {
    newtonLogin: '/auth/newton',
  },
  organization: {
    get: '/organizations',
  },
  reports: {
    user_engagement_limit_page: '/reports/users/engagement?limit={limit}&page={page}',
    userEngagement: '/reports/users/engagement',
  },
  users: {
    get: '/users',
    get_companies: '/users/available-companies',
    forgotPasswordEmail: '/users/password/forgot/email/{email}',
    forgotPasswordCode: '/users/password/verify/{passwordCode}',
    resetPassword: '/users/password/reset/{resetPasswordCode}',
    canUserUpdatePassword: '/users/password/forgot/backoffice/{email}',
  },
  teams: {
    get: '/users/courses/teams',
  },
  chat: {
    get: '/chat',
    getWithCommunication: '/chat?join[0]=communication&join[1]=userReceived&join[2]=userSendId',
    groupedByNotice: '/chat/grouped-by-notice',
    getInbox: '/chat/list-chats-sender?page={page}&limit={limit}',
    update: '/chat/{chatId}',
    markAsRead: '/chat/mark-as-read',
  },
  communications: {
    base: '/communications',
    markAsRead: '/communications/mark-as-read',
    get: '/communications?join[0]=recipient&join[1]=recipient.student',
    update: '/communications/{communicationId}',
  },
  questions: {
    bulk_updt_answer: '/quizzes/questions/answers/:questionId/answers-bulk',
  },
};
